import styled from "styled-components";
import { List, Anchor } from "@ebscois/react-component-library";

export const SyledTablesList = styled(List)`
  margin-top: ${({ theme }) => theme.space.md};
`;

export const StyledTableWrapper = styled(List.Item)`
  padding: ${({ theme }) => theme.space.xs} 0 ${({ theme }) => theme.space.md};
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray400};
`;

export const StyledViewInTopic = styled(Anchor)`
  margin-left: ${({ theme }) => theme.space.xxl};
  font-weight: ${({ theme }) => theme.font.weight.semibold};
`;
